import { LINEAR_BUILDS } from './linear';
import { LOG_ACCEL_BUILDS } from './log-accel';
import { LOG_DECEL_BUILDS } from './log-decel';

export type ShapeFamily = 'log-decel' | 'linear' | 'log-accel';

export interface MasterShape {
  id: string;
  family: ShapeFamily;
  buildId: string;
}

const reversedLogDecelBuilds = [...LOG_DECEL_BUILDS].reverse();

const masterShapeList: MasterShape[] = [
  ...reversedLogDecelBuilds.map((build) => ({
    id: build.id,
    family: 'log-decel' as ShapeFamily,
    buildId: build.id,
  })),
  ...LINEAR_BUILDS.map((build) => ({
    id: build.id,
    family: 'linear' as ShapeFamily,
    buildId: build.id,
  })),
  ...LOG_ACCEL_BUILDS.map((build) => ({
    id: build.id,
    family: 'log-accel' as ShapeFamily,
    buildId: build.id,
  })),
];

// Add a masterId for easy lookups
export const MASTER_SHAPE_LIST = masterShapeList.map((shape, index) => ({
  ...shape,
  masterId: `shape-${String(index + 1).padStart(3, '0')}`,
}));
